import angular from 'angular';

// Component
import component from './recapResponseNavigation.component';

import './recapResponseNavigation.css';

const moduleName = 'recaps.editor.recapResponseNavigation';
let module = angular.module(moduleName, [
]);

module.component('recapResponseNavigation', component);

export default module;
